<template>
  <div class="phone-keyboard">
    <div class="key-group">
      <button class="key" @click="emitValue">1</button>
      <button class="key" @click="emitValue">2</button>
      <button class="key" @click="emitValue">3</button>
    </div>
    <div class="key-group">
      <button class="key" @click="emitValue">4</button>
      <button class="key" @click="emitValue">5</button>
      <button class="key" @click="emitValue">6</button>
    </div>
    <div class="key-group">
      <button class="key" @click="emitValue">7</button>
      <button class="key" @click="emitValue">8</button>
      <button class="key" @click="emitValue">9</button>
    </div>
    <div class="key-group">
      <button class="key" @click="$emit('backspace')">
        <fa icon="chevron-left" />
      </button>
      <button class="key" @click="emitValue">0</button>
    </div>      
  </div>
</template>

<script>
export default {
  name: 'PhoneKeyboard',
  methods: {
    emitValue (e) {
      this.$emit('input', e.target.innerText)
    }
  }
}
</script>

<style lang="scss" scoped>
  .phone-keyboard {
    width: 250px;
  }

  .key-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  button {
    background-color: #009ddb;
    border: none;
    width: 60px;
    height: 60px;
    color: white;
    font-size: 20px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;


    &:focus, &:active {
      background-color: white;
      color: $main;
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PhoneKeyboard.vue